import IsDisplayedIcon from "../../../../assets/svg/test-buy-displayed.svg?react"; //
import IsCleanIcon from "../../../../assets/svg/test-buy-clean.svg?react"; //
import DoesHaveTagIcon from "../../../../assets/svg/test-buy-tag.svg?react";
import BuyInstructionIcon from "../../../../assets/svg/test-buy-tag-filled-in.svg?react";
import PlacedInRangeAreaIcon from "../../../../assets/svg/stack.svg?react";
import IsAvailableAsExpectedIcon from "../../../../assets/svg/test-buy-location.svg?react"; //
import { CriterionKey } from "@coworker/types/lib/testbuy";

export default function useCriterionSVG(criterionKey: CriterionKey) {
  switch (criterionKey) {
    case "IsItDisplayed":
      return <IsDisplayedIcon />;
    case "IsItCleanAndPerfect":
      return <IsCleanIcon />;
    case "DoesItHaveTag":
      return <DoesHaveTagIcon />;
    case "AreBuyInstructionClear":
      return <BuyInstructionIcon />;
    case "IsItPlacedAndGroupInRangeArea":
      return <PlacedInRangeAreaIcon />;
    case "IsItAvailableInIndicatedPosition":
      return <IsAvailableAsExpectedIcon />;
    default:
      return <></>;
  }
}
